// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609011834/js/" + chunkId + "." + {"44":"b6f47e20","225":"8fce746c","481":"19a772a2","486":"c92e323d","770":"7fe07d08"}[chunkId] + ".0.8439672820494265.chunk.js";
};